module.exports = __webpack_public_path__ + "static/casque3-f62f1eee9e55b9e164ece6d55026d10b.png";